import React from 'react';
import CallButton from './CallButton';
import { businessInfo } from '../data/businessData';
import { IMAGE_ASSETS } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Footer() {
  const { t, lang } = useLanguage();

  return (
    <footer className="bg-brand-navy text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 text-center md:text-left">
          {/* Brand & Address */}
          <div className="flex flex-col items-center md:items-start">
            <img 
              src={IMAGE_ASSETS.logo} 
              alt={businessInfo.name} 
              className="h-16 w-auto mb-6 object-contain rounded-lg shadow-md" 
            />
            <p className="text-gray-300 mb-2">{t('common.tagline')}</p>
            <p className="text-gray-300 max-w-xs mb-6">
              {businessInfo.address.street},<br />
              {businessInfo.address.city}, {businessInfo.address.province} {businessInfo.address.postalCode},<br />
              {businessInfo.address.country}
            </p>
            
            {/* Social Media Links */}
            <div className="flex items-center gap-4">
              {businessInfo.socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red hover:text-white transition-all duration-300 group"
                  aria-label={social.name}
                >
                  <SafeIcon 
                    icon={FiIcons[social.icon]} 
                    className="text-xl group-hover:scale-110 transition-transform" 
                  />
                </a>
              ))}
            </div>
          </div>

          {/* Hours */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-lg font-semibold text-brand-gold mb-6 uppercase tracking-wider">
              {t('contact.hours')}
            </h4>
            <ul className="text-gray-300 space-y-3">
              {businessInfo.hours.map((item, idx) => (
                <li key={idx} className="flex flex-col md:flex-row md:justify-between w-full border-b border-white/5 pb-2">
                  <span className="font-medium">{item.days[lang]}</span>
                  <span className="text-sm text-gray-400">{item.time}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Call to Action */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-lg font-semibold text-brand-gold mb-4 uppercase tracking-wider">
              {t('common.bookTable')}
            </h4>
            <p className="text-gray-300 mb-6 font-light">
              {t('common.skipWait')}
            </p>
            <CallButton className="w-full md:w-auto" />
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} {businessInfo.name}. {t('common.rights')}</p>
        </div>
      </div>
    </footer>
  );
}